import React from 'react';
import {Images} from "../constants/Images";

const OpsLogo = ({size = "sm", className, resortLogo, action}) => {
    return (
        <div>
            <img
                src={resortLogo !== undefined ? resortLogo : Images.LOGO}
                className={`ops-icon-logo-${size} ${className} object-fit-contain`}
                onClick={action}
                alt=""
            />
        </div>
    );
};

export default OpsLogo;